import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommunicationService } from '../../http/communication.service';
import { formatDateRangeForFilters } from '../../utils/time';
import { SocialOverviewWidgetApiPaths } from '../../services/types';
import { CreativeGalleryPayload, CreativeGalleryResponse, SocialOverviewApiResponse, SocialOverviewPayload, SocialOverviewPerformancePayload, SocialOverviewPerformanceResponse } from './types';

@Injectable({
    providedIn: 'root'
})
export class SocialOverviewScreenService {

    constructor(private communicationService: CommunicationService) {}

    getSocialOverviewPerformance(payload: SocialOverviewPerformancePayload): Observable<SocialOverviewPerformanceResponse> {
        return this.communicationService.httpPost<SocialOverviewPerformanceResponse>(
            SocialOverviewWidgetApiPaths.PERFORMANCE_OVER_TIME,
            { ...payload, ...formatDateRangeForFilters(payload) }
        ).pipe(
            catchError((error) => {
                console.error('Error fetching social overview performance', error);
                throw error;
            })
        );
    }

    getSocialOverview(payload: SocialOverviewPayload): Observable<SocialOverviewApiResponse> {
        return this.communicationService.httpPost<SocialOverviewApiResponse>(
            SocialOverviewWidgetApiPaths.OVERVIEW_DASHBOARD,
            { ...payload, ...formatDateRangeForFilters(payload) }
        ).pipe(
            catchError((error) => {
                console.error('Error fetching social overview', error);
                throw error;
            })
        );
    }

    getCreativeGallery(payload: CreativeGalleryPayload): Observable<CreativeGalleryResponse> {
        return this.communicationService.httpPost<CreativeGalleryResponse>(
            SocialOverviewWidgetApiPaths.CREATIVE_GALLERY,
            { ...payload, ...formatDateRangeForFilters(payload) }
        ).pipe(
            catchError((error) => {
                console.error('Error fetching creative gallery', error);
                throw error;
            })
        );
    }
}
